<template>
    <div class="upload no-trans">
        <!-- 上传-->
        <form id="uploadForm"   v-show="false">
            <input ref="fileRef" type="file" @change="fileChange">
        </form>
        

        <!-- 引用 -->
        <!-- <upload 
        v-show="false"  
        ref="uploads"
        :show_mb="show_mb"
        :mbs="mbs"
        :show_type="true"
        :types="types"
         ></upload> -->
            <!-- types:JSON.stringify(['jpg','png']) -->
         
    </div>
</template>
<script>
import axios from "axios";
 

export default {
    name: "upload",
    props:{
        // 是否限制大小
        show_mb:{
				type: Boolean,
				default: false
		},
        // 大小
        mbs: {
            type: Number,
            default: 0
		},
        // 是否限制类型
        show_type:{
				type: Boolean,
				default: false
		},
        //类型
        types: {
            type: String,
            default: '[]'
		},
        // 文字提示
        text_up: {
            type: String,
            default: '上传'
		},
    },
    data() {
        return {
            texts:'上传',
            name:'',
            form_data:{},
            // 实例
            // show_mb:true,//是否限制大小
            // mbs:5,//大小
            // show_type:true,//是否限制类型
            // type:JSON.stringify(['jpg','png','pdf']) ,//类型

        };
    },
    methods: {
        uploadFile(data) {
            this.form_data=data
            this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
        },
        fileChange(event) {
         
            // 阻止发生默认行为
            let formData = new FormData()
            let file = this.$refs.fileRef.files[0]
            console.log('上传',file)
            this.file_name=file.name
            let token=localStorage.getItem('token')||this.$route.query.token
            formData.append('token',token)
            formData.append('file',file)
            // this.$parent.upload_url(1)
            if(this.show_mb){
                let size=Number(file.size) 
                size=size/(1024*1024)
                if(this.mbs<size){
                    // this.$parent.upload_url(2)
                    alertErr(`当前限制的文件大小为${this.mbs}mb`)
                    document.getElementById("uploadForm").reset()
                    
                    return
                }
            }
            if(this.show_type){
                let type=file.name.split('.')
                // this.types=JSON.parse(this.types)//不能修改父组件传来的值会报错
                let types_in=JSON.parse(this.types)
                console.log('type',type)
                let flag1= types_in.findIndex(item => item===type[type.length-1] )
                console.log(flag1)
                if(flag1==-1){
                    // this.$parent.upload_url(2)
                    let types=types_in.join(',')
                    console.log('types',types)
                    alertErr(`当前限制的文件类型${types}格式`)
                    document.getElementById("uploadForm").reset()
                    
                    return
                }
            }
            this.onUpload(formData)
        },
        onUpload (formData) {
            const loading = this.$loading({
                lock: true,
                text: '上传中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            this.$api_up("upload",formData ,"post",{}).then((res) => {
                loading.close();
                if(res.code==1){
                    console.log("文件", res);
                    alertSucc('上传成功')
                    let datas={
                        file_name: this.file_name,
                        ...this.form_data,
                    }
                    this.$parent.upload_url(res.data,datas)
                    // 上传成功的是时候去除原来的文件
                    document.getElementById("uploadForm").reset()
                    // this.$refs.fileRef.reset()
                }else{
                    document.getElementById("uploadForm").reset()
                    // alert(res)
                    alertErr(res.msg)
                }
              
            });
        }
    },
    computed: {
    },

    watch: {},


    created() {
    this.texts=this.text_up
    },


};
</script>
  
<style scoped lang="less">
.upload {
   
}
</style>
  
<style scoped lang="less">
@media (max-width: 1024px) {
    .upload.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
}
</style>
